import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src", "alt"]
const _hoisted_2 = {
  key: 1,
  class: "text-uppercase"
}

import { PlatformError } from '@inpart-io/devtools';
import { type DataType as IufDataType, type IBinaryDataRef, type IDataObject } from '@inpart-io/devtools-iap';
import { type DataType } from '@inpart-io/padme-iap';
import { computed, type PropType, type Ref, ref, watch } from 'vue';

import { useDataObjectHelper } from '@/composables/useDataObjectHelper';

/**
 * IUF Avatar component
 * @displayName IufAvatar
 */


export default /*#__PURE__*/_defineComponent({
  __name: 'iuf-avatar',
  props: {
    dataType: {
        type: String as PropType<DataType | IufDataType>,
        required: true
    },
    /**
     * Debug mode, if true, will log additional information to the console
     */
    debug: { type: Boolean, required: false, default: false },
    /**
     * The color of the avatar.
     */
    color: {
        type: String as PropType<string>,
        required: false,
        default: 'purple-light'
    },
    /**
     * The name of the binaryfield.
     */
    field: { type: String as PropType<string>, required: true },
    /**
     * The main data object, containing a binaryfield.
     */
    object: { type: Object as PropType<IDataObject>, required: true },
    /**
     * The size of Quasar's avatar component, defined in CSS units including unit (ex: 24px) name or standard size name (xs|sm|md|lg|xl)
     * @values xs, sm, md, lg, xl
     */
    size: { type: String as PropType<string>, required: true },
    /**
     * The alternative text to display, in case the binary field is null
     */
    text: { type: String as PropType<string>, required: true }
},
  setup(__props) {

const props = __props;



/**
 * Contains the blob url for this binary field
 */
const avatarUrl: Ref<string | null> = ref(null);

/**
 * Returns update date for this binary field
 */
const modifiedOn = computed((): string | undefined => {
    return (props.object?.[props.field] as IBinaryDataRef)?.updatedDate;
});

const { getDataObjectManager } = useDataObjectHelper();

watch(
    modifiedOn,
    async (newModifiedOn: string | undefined): Promise<void> => {
        try {
            if (props.object.dobjId === undefined) {
                console.error('The object does not have a dobjId');
                throw new PlatformError('The object does not have a dobjId');
            }

            if (props.object['@type'] !== undefined && props.object.dobjId !== undefined) {
                if (props.debug) {
                    console.debug(`New updatedDate on ${props.field} for ${props.object['@type']}.${props.object.dobjId}`, newModifiedOn);
                }
            }
            avatarUrl.value =
                newModifiedOn !== undefined
                    ? await getDataObjectManager(props.dataType).getBinaryFieldBlobUrl(props.object.dobjId, props.field, newModifiedOn)
                    : null;
        } catch (error) {
            if (props.debug) {
                console.error('An error occurred while retrieving an avatar', error);
            }
        }
    },
    {
        immediate: true
    }
);

return (_ctx: any,_cache: any) => {
  const _component_q_avatar = _resolveComponent("q-avatar")!

  return (_openBlock(), _createBlock(_component_q_avatar, {
    color: __props.color,
    size: __props.size,
    "text-color": "purple"
  }, {
    default: _withCtx(() => [
      (avatarUrl.value)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: avatarUrl.value,
            alt: __props.text
          }, null, 8, _hoisted_1))
        : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(__props.text), 1))
    ]),
    _: 1
  }, 8, ["color", "size"]))
}
}

})